module.exports = __webpack_public_path__ + "img/10_sherry_d.2376c6cb.png";